import { Dto } from '@mango/core';
import { Factuur } from './factuur';

@Dto({fullName: "CIJBorculo.Logic.exportExact"})
export class exportExact {
    facturen?: Factuur[];    
}
